import type { ProductListingResource, ProductVariantResource, OrderItemWithStock } from '@storefront/resources';

interface GtagSale {
  header: string;
  type: string;
  placement: string;
  products: ProductListingResource[];
}

export function viewPromotionEvent(sale: GtagSale) {
  let mapped = sale.products.map((item) => {
    return {
      item_name: item.title,
      item_id: item.id,
      price: Number(Number(item.priceGross).toFixed(2)),
      quantity: 1,
      ...(item.type !== 'FLEXIBLE' && {
        discount: calculateItemDiscount(item),
      }),
    };
  });

  return {
    'event': 'view_promotion',
    'ecommerce': {
      promotion_name: sale.header,
      creative_name: sale.type,
      creative_slot: sale.placement,
      items: mapped,
    },
  };
}


export function selectPromotionEvent(sale: Omit<GtagSale, 'products'>, item: ProductListingResource) {
  return {
    'event': 'select_promotion',
    'ecommerce': {
      promotion_name: sale.header,
      creative_name: sale.type,
      creative_slot: sale.placement,
      items: [
        {
          item_name: item.title,
          item_id: item.id,
          price: Number(Number(item.priceGross).toFixed(2)),
          quantity: 1,
          ...(item.type !== 'FLEXIBLE' && {
            discount: calculateItemDiscount(item),
          }),
        },
      ],
    },
  };
}


function calculateItemDiscount(item: ProductListingResource | ProductVariantResource | OrderItemWithStock): number {
  if (item.regularGross === null) {
    return 0;
  }

  const regularGross = Number(item.regularGross);
  const priceGross = Number(item.priceGross);

  return Number((regularGross - priceGross).toFixed(2));
}